// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "portal/static/css/" + chunkId + "." + "6e851545" + ".chunk.css";
};